(() => {
  const ANGLES = {
    lluvia: {
      badge: 'Solución para días fríos y lluviosos',
      subtitle: 'Seca tu ropa dentro de casa sin depender del clima.'
    },
    espacio: {
      badge: 'Más espacio, menos tendederos',
      subtitle: 'Una alternativa plegable para departamentos y hogares con poco espacio.'
    },
    urgencia: {
      badge: 'Cuando necesitas esa prenda pronto',
      subtitle: 'Ayuda a secar la ropa que necesitas sin esperar varios días.'
    },
    compacta: {
      badge: 'Sin una secadora gigante',
      subtitle: 'Una solución portátil que se arma, se enchufa y se guarda cuando no la usas.'
    }
  };

  const applyAngle = () => {
    const requested = new URLSearchParams(window.location.search).get('angle');
    const angle = Object.prototype.hasOwnProperty.call(ANGLES, requested) ? requested : 'lluvia';
    const copy = ANGLES[angle];

    document.documentElement.dataset.lavenzoAngle = angle;

    document.querySelectorAll('[data-lv-angle-badge]').forEach((node) => {
      node.textContent = copy.badge;
    });
    document.querySelectorAll('[data-lv-angle-subtitle]').forEach((node) => {
      node.textContent = copy.subtitle;
    });
    document.querySelectorAll('[data-lv-angle-card]').forEach((card) => {
      const active = card.dataset.lvAngleCard === angle;
      card.toggleAttribute('data-active', active);
      card.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'LavenzoAngleView', { angle });
    }
  };

  const bindBuyLinks = () => {
    document.querySelectorAll('[data-lv-scroll-buy]').forEach((button) => {
      button.addEventListener('click', () => {
        const form = document.querySelector('.main-product-form');
        if (!form) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        const submit = form.querySelector('button[type="submit"]');
        if (submit) submit.focus({ preventScroll: true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyAngle();
      bindBuyLinks();
    }, { once: true });
  } else {
    applyAngle();
    bindBuyLinks();
  }
})();
